import { render } from "./SlidePreviewText.vue?vue&type=template&id=9cf459b0"
import script from "./SlidePreviewText.vue?vue&type=script&lang=js"
export * from "./SlidePreviewText.vue?vue&type=script&lang=js"

import "./SlidePreviewText.vue?vue&type=style&index=0&id=9cf459b0&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__